module.exports = __webpack_public_path__ + "5f54f66f965d0a77c55de24c8bb58da8.svg";